// Global settings shell: page title, then the active section below it.
// Section navigation lives in the main sidebar (Settings > Order recovery /
// Loyalty program / Referral program / Awqaf donations / Rated orders) — register new routes in ./index.js.
import React from 'react';
import './settings.css';

export const SettingsCard = ({ title, description, status, children, footer }) => (
  <div className="st-card">
    <div className="st-card-head">
      <div>
        <h5>{title}</h5>
        {description ? <p>{description}</p> : null}
      </div>
      {status || null}
    </div>
    <div className="st-card-body">{children}</div>
    {footer ? <div className="st-card-foot">{footer}</div> : null}
  </div>
);

export const StatusPill = ({ on, test, onLabel = 'Active', offLabel = 'Off', testLabel = 'Test mode' }) => (
  <span className={`st-pill ${test ? 'test' : on ? 'on' : 'off'}`}><i />{test ? testLabel : on ? onLabel : offLabel}</span>
);

export const Field = ({ label, help, children }) => (
  <div className="form-group st-field">
    {label ? <label>{label}</label> : null}
    {help ? <div className="st-help">{help}</div> : null}
    {children}
  </div>
);

// One setting as a list row: label + help on the left, a compact control (optionally with a unit) on the right.
// Rows live inside <SettingList>; inputs line up in one column regardless of help-text length.
export const SettingList = ({ children }) => <div className="st-list">{children}</div>;

// wide: stack the control under the label at full width (textareas, text pairs).
export const SettingRow = ({ label, help, wide, children }) => (
  <div className={`st-row${wide ? ' wide' : ''}`}>
    <div className="st-row-label">
      <b>{label}</b>
      {help ? <span>{help}</span> : null}
    </div>
    <div className="st-row-ctl">{children}</div>
  </div>
);

// Two inputs side by side with small language captions (English | Arabic copy).
export const LangPair = ({ left, right, leftLabel = 'English', rightLabel = 'العربية' }) => (
  <div className="st-pair">
    <div><div className="st-pair-cap">{leftLabel}</div>{left}</div>
    <div><div className="st-pair-cap" dir="rtl">{rightLabel}</div>{right}</div>
  </div>
);

const SettingsLayout = ({ children }) => (
  <div className="st-page">
    <h1>Settings</h1>
    <div className="st-sub">Global switches and parameters for the Chill platform. Changes apply to live users; running Cloud Functions pick them up within five minutes.</div>
    <div>{children}</div>
  </div>
);

export default SettingsLayout;
